export default __webpack_public_path__ + "static/ndou-0d50fa63576e0d5f9bfbf61088a698a9.jpg";